import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'

export const getInformations = createAsyncThunk('get/informations', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/store/${window.config.STORE_ID}/informations?filter_bottom=1`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getInformationsByFilteredTop = createAsyncThunk('get/informations/top', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/store/${window.config.STORE_ID}/informations?filter_top=1`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})